import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { useAuthUser } from "@/hooks/useAuthUser";
export default function LandingRouter() {
	const [, setLocation] = useLocation();
	const [loading, setLoading] = useState(true);
	const { user, isLoading } = useAuthUser();
	console.log("[AUTH_DEBUG]", "Loaded user in LandingRouter.tsx", user);
	const isAuthenticated = !!user;
	console.log("[LANDING_ROUTER] User:", { id: user?.id, role: user?.role, roles: user?.roles });

	useEffect(() => {
		if (isLoading) return;
		if (!isAuthenticated) {
			console.log("[LANDING_ROUTER] Not authenticated, redirecting to /login");
			setLocation("/login");
			setLoading(false);
			return;
		}
		// Enable only after reviewing legacy flags; email-link setup remains explicit.
		if (import.meta.env.VITE_ENABLE_DB_PASSWORD_SETUP_ROUTING === 'true' && user?.requirePasswordChange) {
			setLocation('/set-password');
			setLoading(false);
			return;
		}

		// Determine user role first (needed for onboarding check)
		const rolesArray = (user?.roles || []) as string[];
		const primaryRole = user?.role || rolesArray[0];
		const isAdmin = primaryRole === "admin" || primaryRole === "superadmin" || primaryRole === "super_admin" || (Array.isArray(rolesArray) && (rolesArray.includes("admin") || rolesArray.includes("superadmin") || rolesArray.includes("super_admin")));

		// Check onboarding status - skip for admins and if field doesn't exist (migration not run yet)
		const hasOnboardingField = 'onboardingCompleted' in (user as any);
		const needsOnboarding = !isAdmin && hasOnboardingField && !(user as any)?.onboardingCompleted;

		if (needsOnboarding) {
			console.log("[LANDING_ROUTER] Onboarding not completed, redirecting to /onboarding");
			setLocation("/onboarding");
			setLoading(false);
			return;
		} else if (!hasOnboardingField) {
			console.log("[LANDING_ROUTER] Onboarding field not found (migration not run), skipping onboarding");
		} else if (isAdmin && !((user as any)?.onboardingCompleted)) {
			console.log("[LANDING_ROUTER] Admin user, skipping onboarding (admins don't need onboarding)");
		}
		const isReviewer = user?.role === "reviewer" || (Array.isArray(rolesArray) && rolesArray.includes("reviewer"));
		const isPortalExternal = (user as { accessMode?: string })?.accessMode === "portal_external";

		if (isPortalExternal) {
			console.log("[LANDING_ROUTER] Portal external user, redirecting to /portal");
			setLocation("/portal");
		} else if (isAdmin) {
			console.log("[LANDING_ROUTER] Admin detected, redirecting to /campaigns");
			setLocation("/campaigns");
		} else if (isReviewer) {
			console.log("[LANDING_ROUTER] Reviewer detected, redirecting to /admin/activation-cockpit/review");
			setLocation("/admin/activation-cockpit/review");
		} else {
			// Operators: Proscriptive Workflow v1.0 - Start at cycle selector
			console.log("[LANDING_ROUTER] Operator detected, redirecting to /mobile/cycle-selector");
			setLocation("/mobile/cycle-selector");
		}
		setLoading(false);
	}, [setLocation, isLoading, isAuthenticated, user]);

	if (loading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="text-center">
					<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
					<p className="mt-2 text-gray-600">Loading...</p>
				</div>
			</div>
		);
	}

	return null;
}


